import React from 'react';

import FormSupervisor  from 'components/Tvendo/Sale/QuotaBPartner/GoogleForm/Diccionario/List.js';

export default function () {
  return <FormSupervisor  />;
}